import { useDispatch } from 'react-redux'
import { GCDSDropdown } from '@gocanvas/gcds/components'

export const SettingsFontStyleSelect = ({
  id,
  label,
  property,
  choices = [],
  update,
  data = {},
  isDisabled = () => false,
}) => {
  const dispatch = useDispatch()
  const { fontFamily } = data
  const options = choices.map(choice => ({
    ...choice,
    style: {
      fontFamily,
      ...choice.style,
    },
  }))

  // build style payload with defaults
  const buildStylePayload = option => ({
    [property]: option.value,
    ...option.additionalProperties,
  })

  // check if an option matches the current data
  const isOptionSelected = option => {
    const allProperties = {
      [property]: option.value,
      ...option.additionalProperties,
    }
    return Object.entries(allProperties).every(
      ([key, val]) => data[key] === val
    )
  }

  let selected = options.find(isOptionSelected)

  // If the current style is not available for the selected font, reset to the first available option
  if (!selected && options.length > 0) {
    selected = options[0]
    dispatch(update(buildStylePayload(selected)))
  }

  const handleChange = ({ label: selectedLabel }) => {
    const option = options.find(opt => opt.label === selectedLabel)

    dispatch(update(buildStylePayload(option)))
  }

  return (
    <GCDSDropdown
      id={id}
      label={label}
      value={selected}
      onChange={handleChange}
      disabled={isDisabled(data)}
      options={options}
      isOptionSelected={isOptionSelected}
      inputType="secondary"
      size="large"
    />
  )
}
